import React, { Fragment } from 'react';

import { Slide } from "../../display_wallet.js"
import { With3Tabs } from "../../components/With3Tabs";

import Slide_Backup from "./Slide_Backup.js"
import Slide_Freeze from "./Slide_Freeze.js"
import Slide_Revoke from "./Slide_Revoke.js"
import { Alert } from 'react-bootstrap';
import Bold from '../../components/Bold.js';
import { FaAlertIcon, FaInfoCircle } from '../../helpers/helpers.js';



export const AlertRevokeAutoConvert = () => {
	return (
		<Alert variant="light">
			<FaInfoCircle />
			Cette action va permettre aux utilisateurs d'échanger leurs coins de l'ancien contrat vers le nouveau
			(en les détruisant).
			Cette procédure est récursive: toutes les coins des contrats liés avant sont aussi échangeables.
		</Alert>
	)
}


export const AlertRevokeCheckAddress = () => {
	return (
		<Alert variant="danger">
			<Bold>
				<FaAlertIcon />
				Cette action ne peut être effectuée qu'une seule fois par contrat.&nbsp;
				Assurez-vous d'avoir entré la bonne adresse.
			</Bold>
		</Alert>
	)
}


export default class Slide_AllRevoke extends React.PureComponent {
	render() {
		var jsx_1 = <Slide_Backup {...this.props} />
		var jsx_2 = <Slide_Freeze {...this.props} />
		var jsx_3 = <Slide_Revoke {...this.props} />

		return (
			<Slide num={this.props.num} style={{ paddingTop: "0px", overflowX: "hidden" }}>
				<With3Tabs
					startingtab="1"
					title_tab1="Backup"
					title_tab2="Freeze"
					title_tab3="Revoke"
					content_tab1={jsx_1}
					content_tab2={jsx_2}
					content_tab3={jsx_3}
				/>
			</Slide>
		)
	}
}
